import { List, ListItem, Typography, ListItemSecondaryAction, Paper, Divider, ListItemIcon, Grid } from '@mui/material';
// import { pushAppRoute } from '../../data/domain/route-manager';
// import { useHistory } from 'react-router';
import React, { useState, useEffect } from 'react';
import { ContentContainer } from '../ContentContainer';
import { Status } from '../../types';
import { AppRoute } from '../../routes';
import { StatusTag } from '../StatusTag/StatusTag';
import { DevicePropertiesDetails } from '../../types/device';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { PxChildDeviceList } from './PxChildDeviceList';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
//import { useToasts } from '../../data/DataProviders/ToastProvider';
//import { pushAppRoute } from '../../data/domain/route-manager';
//import { useHistory } from 'react-router';
import _ from 'lodash';
//import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';

export const PxDeviceProfileData: React.FC<{
    backAppRoute: AppRoute;
    data: DevicePropertiesDetails | null;
    childDeviceList: any[];
}> = (props) => {
    const currentAppRoute = useCurrentAppRoute();
    // const deviceDetails = useDeviceDetails();
    // const { addToast } = useToasts();
    // const history = useHistory();
    const classes = deviceStyles();
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null>();
    const [siteName, setSiteName] = useState('');
    const realTimeSiteData = useSignalRSiteData();

    useEffect(() => {
        if (props.data) {
            setDeviceStatus(props.data.status);
            setSiteName(props.data.siteName || '');
        }
    }, [props.data]);

    // const navigateToSiteProfile = (): void => {
    //     if (currentAppRoute.type === 'PxDeviceProfile' && props.data)
    //         pushAppRoute(history, {
    //             type: 'SiteProfile',
    //             //deviceId: props.data.id,
    //             locationId: currentAppRoute.locationId,
    //             orgId: currentAppRoute.orgId,
    //             siteId: currentAppRoute.siteId,

    //         });
    // };

    useEffect(() => {
        if (realTimeSiteData && realTimeSiteData.devices) {
            if (props.data) {
                const updatedDeviceStatus = _.find(realTimeSiteData.devices, {
                    deviceId: props.data.id,
                });
                if (updatedDeviceStatus) {
                    setDeviceStatus(updatedDeviceStatus.status);
                    setSiteName(props.data.siteName || '');
                }
            }
        }
    }, [realTimeSiteData]);

    return (
        <>
            <ContentContainer>
                {props.data &&
                    currentAppRoute.type === 'PxDeviceProfile' &&
                    props.data &&
                    props.data.vendor === 'Eaton Corporation' && (
                        <>
                            <NavigationHeader
                                for="Connected Device"
                                siteName={siteName}
                                connectedDevice={props.data.name || ''}
                                device={''}
                            />
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Paper>
                                        <List>
                                            <ListItem data-testid="device-name">
                                                <Typography variant="h6" color="primary">
                                                    {props.data.name}
                                                </Typography>

                                                <ListItemSecondaryAction>
                                                    <ListItemIcon
                                                        data-testid="device-status-icon"
                                                        style={{ display: 'block' }}
                                                    >
                                                        {deviceStatus ? (
                                                            <StatusTag
                                                                status={Status.Online}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        ) : (
                                                            <StatusTag
                                                                status={Status.Offline}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        )}
                                                    </ListItemIcon>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <ListItem data-testid="device-type" className={classes.margin8}>
                                                <LabelWithSubTitle title={props.data.type} subTitle="Device Type" />
                                            </ListItem>

                                            <Divider />
                                            <ListItem data-testid="guid" className={classes.margin8}>
                                                <LabelWithSubTitle title="GUID" subTitle={props.data.id} />
                                            </ListItem>
                                        </List>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <DataProviderCache for={'device-details-child-list'}>
                                        <PxChildDeviceList
                                            childDeviceData={props.childDeviceList}
                                            parentDeviceId={props.data.id}
                                        />
                                    </DataProviderCache>
                                </Grid>
                            </Grid>
                        </>
                    )}
            </ContentContainer>
        </>
    );
};
